import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { learnListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function LearnList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [userData, setUserData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getUser = async (params) => {
    const path = "admin/learns";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setUserData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getUser({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getUser(allFilter);
  };

  const data = [];

  userData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      faStatus:
        (item.status === "active"
          ? "فعال"
          : item.status === "pending"
          ? "انتظار"
          : "غیرفعال") || "pending",
      status: item.status,
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editLearn = (singleLearn) => {
    navigate("/edit-learn", { state: singleLearn });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست آموزش ها"} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={learnListColumns} rows={data} onEdit={editLearn} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
